"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _assertThisInitialized = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidStateError = exports.UnsupportedError = void 0;
/**
 * Error indicating not support for something.
 */

var UnsupportedError = /*#__PURE__*/function (_Error) {
  _inherits(UnsupportedError, _Error);

  var _super = _createSuper(UnsupportedError);

  function UnsupportedError(message) {
    var _this;

    _classCallCheck(this, UnsupportedError);

    _this = _super.call(this, message);
    _this.name = 'UnsupportedError';

    if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
      {
        // @ts-ignore
        Error.captureStackTrace(_assertThisInitialized(_this), UnsupportedError);
      } else {
      _this.stack = new Error(message).stack;
    }

    return _this;
  }

  return UnsupportedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.UnsupportedError = UnsupportedError;
/**
 * Error produced when calling a method in an invalid state.
 */

var InvalidStateError = /*#__PURE__*/function (_Error2) {
  _inherits(InvalidStateError, _Error2);

  var _super2 = _createSuper(InvalidStateError);

  function InvalidStateError(message) {
    var _this2;

    _classCallCheck(this, InvalidStateError);

    _this2 = _super2.call(this, message);
    _this2.name = 'InvalidStateError';

    if (Error.hasOwnProperty('captureStackTrace')) // Just in V8.
      {
        // @ts-ignore
        Error.captureStackTrace(_assertThisInitialized(_this2), InvalidStateError);
      } else {
      _this2.stack = new Error(message).stack;
    }

    return _this2;
  }

  return InvalidStateError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.InvalidStateError = InvalidStateError;